export enum ActionTypes {
    FETCH_FEE_DETAILS = 'app/table/FETCH_FEE_DETAILS)',
}